import { RootState } from '../../rootReducer'

export const modalConfirmVisible = (state: RootState) => state.modalConfirm.isVisible
export const modalConfirmData = (state: RootState) => state.modalConfirm.data
